<template>
  <div>
    <wt-radio-box
      v-for="q in qualityOptions"
      :key="q.value"
      group="quality-options-group"
      :selected="isQualitySelected(q)"
      :value="q.value"
      :labelRight="q.label"
      @select="qualityChanged(q)"
    />
  </div>
</template>

<script lang="js">
import app from 'app';

export default app.Vue.extend({
  data() {
    return {
      qualityOptions: [
        {
          label: 'All',
          value: null,
        },
        {
          label: '1080p and up',
          value: 'RES1080P',
        },
      ],
    };
  },

  computed: Object.assign({
    hasQualitySelected() {
      const qualities = this.contextFilters.videoQuality;
      return _.isDefined(qualities) && qualities.length;
    },
  }, app.Vuex.mapGetters(['contextFilters'])),

  analytics: {
    'filterByQuality': 'Filter By Quality',
  },

  props: {},

  methods: Object.assign({
    resetQualities(e) {
      if (e) {
        e.stopPropagation();
      }
      this.SET_QUALITY_FILTER_SELECTION([]);
      this.sendEvent();
      this.$emit('search');
    },

    isQualitySelected(q) {
      return this.contextFilters.videoQuality === q.value;
    },

    qualityChanged(q) {
      this.SET_QUALITY_FILTER_SELECTION(q.value);
      this.sendEvent();
      this.sendEvent();
      this.$emit('search');
    },

    sendEvent() {
      const payload = {};
      payload.quality = !_.isEmpty(this.contextFilters.videoQuality) ? '1080p and up' : 'all';
      this.$triggerAnalytics('filterByQuality', payload);
    },

  }, app.Vuex.mapActions([
    'SET_QUALITY_FILTER_SELECTION',
  ])),
});
</script>

<style lang="scss"></style>
